export default [
  {
    path: '/conciliacao-v2',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Conciliações Histórico',
        path: 'historico',
        component: () => import('@/views/conciliacoes/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Conciliações' }]
        }
      },
      {
        name: 'Selecionar tipo Conciliação',
        path: 'edit',
        component: () => import('@/views/conciliacoes/EscolherTipoConciliacao.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Conciliações', path: '/conciliacao-v2/historico' },
            { name: 'Tipo' }
          ]
        }
      },
      {
        name: 'Conciliações Adicionar Express',
        path: 'edit/express',
        component: () => import('@/views/conciliacoes/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Conciliações', path: '/conciliacao-v2/historico' },
            { name: 'Tipo', path: '/conciliacao-v2/edit' },
            { name: 'Express' }
          ]
        }
      },
      {
        name: 'Conciliações Adicionar Custom',
        path: 'edit/custom',
        component: () => import('@/views/conciliacoes/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Conciliações', path: '/conciliacao-v2/historico' },
            { name: 'Tipo', path: '/conciliacao-v2/edit' },
            { name: 'Custom' }
          ]
        }
      },
      {
        name: 'Conciliações Editar Express',
        path: 'edit/express/:id',
        component: () => import('@/views/conciliacoes/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Conciliações', path: '/conciliacao-v2/historico' },
            { name: 'Tipo', path: '/conciliacao-v2/edit' },
            { name: 'Express' }
          ]
        }
      },
      {
        name: 'Conciliações Editar Custom',
        path: 'edit/custom/:id',
        component: () => import('@/views/conciliacoes/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Conciliações', path: '/conciliacao-v2/historico' },
            { name: 'Tipo', path: '/conciliacao-v2/edit' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
